import React, { useState, useEffect } from 'react';
import { Plus, CheckCircle } from 'lucide-react';
import { KTProject, KTTask } from '../types/kt-types';
import { saveProjectsToLocalStorage, saveTasksToLocalStorage, loadProjectsFromLocalStorage, loadTasksFromLocalStorage } from '../utils/localStorage.ts';
import KTProjectsTable from './KTProjectsTable.tsx';
import NewKTProjectModal from './NewKTProjectModal.tsx';
import TaskModal from './TaskModal.tsx';
import axios from 'axios';
import { getToken } from '../auth/authConfig';

const EmployeeDashboard: React.FC = () => {
  const [selectedTask, setSelectedTask] = useState<KTTask | null>(null);
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showKTForm, setShowKTForm] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [data,setData] = useState<any>();
  const [ktProjects, setKtProjects] = useState<KTProject[]>([]);
  const [ktTasks, setKtTasks] = useState<KTTask[]>([]);
  const [selectedProject, setSelectedProject] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadedProjects = loadProjectsFromLocalStorage();
    const loadedTasks = loadTasksFromLocalStorage();
    setKtProjects(loadedProjects);
    setKtTasks(loadedTasks);
  }, []);

  useEffect(() => {
    if (ktProjects.length > 0) {
      saveProjectsToLocalStorage(ktProjects);
    }
  }, [ktProjects]);

  useEffect(() => {
    if (ktTasks.length > 0) {
      saveTasksToLocalStorage(ktTasks);
    }
  }, [ktTasks]);

  const handleViewTask = (task: KTTask) => {
    setSelectedTask(task);
    setShowTaskModal(true);
  };

  const handleSubmitKTForm = ({ formData, uploadedDocuments, sharepointUrls, emailDocuments }: any) => {
    const newKTProject: KTProject = {
      id: Date.now().toString(),
      projectName: formData && formData.projectName,
      role: formData.role,
      department: formData.department,
      startDate: formData.startDate,
      endDate: formData.endDate,
      status: 'pending',
      progress: 0,
      description: formData.description,
      manager: formData.manager,
      keyResponsibilities: formData.keyResponsibilities,
      criticalProjects: formData.criticalProjects,
      uploadedDocuments: uploadedDocuments,
      sharepointUrls: sharepointUrls,
      emailDocuments: emailDocuments
    };

    const endDate = new Date(formData.endDate);
    const today = new Date();
    const daysRemaining = Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 3600 * 24));

    const newKTTask: KTTask = {
      id: (Date.now() + 1).toString(),
      ktId: `kt-${Date.now()}`,
      role: formData.role,
      department: formData.department,
      lastDay: formData.endDate,
      status: 'pending',
      daysRemaining: Math.max(0, daysRemaining)
    };
    
    setKtProjects(prev => [...prev, newKTProject]);
    setKtTasks(prev => [...prev, newKTTask]);
    
    setShowKTForm(false);
    setShowSuccessMessage(true);
    setTimeout(() => setShowSuccessMessage(false), 3000);
  };


  console.log('Rendering EmployeeDashboard with projects:', ktProjects,selectedTask);

  const employeeDetails = async () => {
    try {
      const baseurl = `${process.env.REACT_APP_WEB_TOOL_API_BASE_URL}/employee`;
      const token = await getToken();
      setLoading(true)
      const response = await axios.get(baseurl, {
        headers: { 'oidc-token': token }
      });
  
      // Axios returns data directly in response.data
      const data = response.data;
      if(response.status === 200) {
        setData(data?.data);
        setLoading(false)

      }
      console.log('Employee details fetched:', data);
    } catch (error) {
      console.error('Error fetching employee details:', error);
      setLoading(false)

    }
  };
  
  useEffect(() => {
    console.log('Fetching employee details...');
    employeeDetails()
  }, []);

  useEffect(() => {
    console.log('Selected project changed:', selectedProject);
  }, [selectedProject]);

  if (loading) {
    return    <div
    role="status"
    style={{
      position: "absolute",
      left: "0px",
      right: "0px",
      top: "0px",
      bottom: "0px",
      background: "rgba(0,0,0,0.8)",
      zIndex: "99999",
      display: "grid",
      alignContent:"center"
      ,justifyContent: "center",
      justifyItems: "center",
      alignItems: "center",
    }}
  >
    <svg
      aria-hidden="true"
      className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-purple-600"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
    <span className="pt-4 text-white">Loading Employee, Dashboard Please wait...</span>

  </div>;
  }

 

  return (
    <div className="p-6 welcome-screen">
      {/* Success Message */}
      {showSuccessMessage && (
        <div style={{zIndex:"99999"}} className="fixed top-4 right-4 z-50 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg shadow-lg">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5" />
            <span className="font-medium">
              KT project created successfully! Email sent to manager for review.
            </span>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Employee Dashboard</h1>
            <p className="text-gray-600 mt-2">Manage your knowledge transfer projects and tasks</p>
          </div>
          <div className="flex gap-2">
            {/* <button
              onClick={clearLocalStorage}
              className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors text-sm"
            >
              Clear Data
            </button> */}
            {/* <button
              onClick={() => setShowKTForm(true)}
              className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Plus className="w-4 h-4" />
              New KT Project
            </button> */}
          </div>
        </div>
      </div>

      {/* KT Projects Table */}
      <KTProjectsTable 
        projects={ktProjects}
        tasks={ktTasks}
        onViewTask={handleViewTask}
        data = {data}
        setShowKTForm={setShowKTForm}
        setSelectedProject ={setSelectedProject}
      />

      {/* New KT Project Form Modal */}
      <NewKTProjectModal
        isOpen={showKTForm}
        onClose={() => setShowKTForm(false)}
        onSubmit={handleSubmitKTForm}
        ktProjects={ktProjects}
        selectedProject={selectedProject || {}}
        employeeDetails={employeeDetails}
      />

      {/* Task Modal */}
      <TaskModal
        isOpen={showTaskModal}
        task={selectedTask}
        onClose={() => setShowTaskModal(false)}
        selectedProject={selectedProject || {}}

      />
    </div>
  );
};

export default EmployeeDashboard;